import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { EmployeeDetails } from '../../../models/employee/EmployeeDetails';
import { EmployeeAdapter } from './EmployeeAdapter';
import { CapabilityAdapter } from './CapabilityAdapter';
import { EmployeeRankAdapter } from './EmployeeRankAdapter';
import { ContractHoursAdapter } from './ContractHoursAdapter';
import { MaximumWorkingHoursAdapter } from './MaxWorkHoursAdapter';
import { AvailabilityAdapter } from './AvailabilityAdapter';
import { EmployeeResponse } from '../../../../interfaces/response/EmployeeResponse';
import { PreferredTimeOffAdapter } from './PreferredTimeOffAdapter';
import { TemporaryPreferredTimeOffAdapter } from './TemporaryPreferredTimeOffAdapter';
import { ManagerSettingsAdapter } from './ManagerSettingsAdapter';

/**
 * An adapter converts employee details HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class EmployeeDetailsAdapter implements Adapter<EmployeeDetails> {

  /**
   * Converts employee details HTTP response to {@link EmployeeDetails}.
   * @param item employee details HTTP response.
   */
  adapt(item: EmployeeResponse): EmployeeDetails {
    const employeeAdapter = new EmployeeAdapter();
    const capabilityAdapter = new CapabilityAdapter();
    const maximumWorkingHoursAdapter = new MaximumWorkingHoursAdapter();
    const availabilityAdapter = new AvailabilityAdapter();
    const preferredTimeOffAdapter = new PreferredTimeOffAdapter();
    const temporaryPreferredTimeOffAdapter = new TemporaryPreferredTimeOffAdapter();
    const employeeRankAdapter = new EmployeeRankAdapter();
    const contractHoursAdapter = new ContractHoursAdapter();
    const managerSettingsAdapter = new ManagerSettingsAdapter();
    return new EmployeeDetails(
      employeeAdapter.adapt(item.positionSummary),
      capabilityAdapter.adapt(item.capabilities),
      maximumWorkingHoursAdapter.adapt(item.maximumWorkingHours),
      availabilityAdapter.adapt(item.availabilities),
      preferredTimeOffAdapter.adapt(item.preferredDaysOff),
      temporaryPreferredTimeOffAdapter.adapt(item.temporaryPreferredDaysOff),
      employeeRankAdapter.adapt(item.ranks),
      contractHoursAdapter.adapt(item.contractHours),
      managerSettingsAdapter.adapt(item.managerSettings)
    );
  }
}
